import { type Product } from "@repo/schemas";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../base/carousel";
import { ProductCard } from "./ProductCard";

export function RelatedProducts({ products }: { products: Product[] }) {
  if (products.length === 0) {
    return null;
  }
  return (
    <div>
      <h2 className="mb-2 text-lg font-bold">Related Products</h2>
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent>
          {products.map((product) => (
            <CarouselItem key={product.images[0].src} className="basis-64">
              <ProductCard product={product} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-0 opacity-40 hover:opacity-100" />
        <CarouselNext className="right-0 opacity-40 hover:opacity-100" />
      </Carousel>
    </div>
  );
}
